export const CLASS_NAMES = {
  containerBase:
    'flex flex-1 flex-row space-between items-top min-h-20 pr-3 pl-6 relative overflow-hidden',
  content: 'flex flex-1 items-center',
  options: 'flex flex-row items-center my-5 mx-4 absolute right-0 top-0',
};
